import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Logo from '../Pictures/logo.jpg'
import LogoTransparent from '../Pictures/logo_low.png'
import { Icon } from 'semantic-ui-react'
import { Popover } from 'antd'

const Navigation = () => {
  const [sticky, setSticky] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()
  const pathname = location.pathname

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setSticky(true)
      } else {
        setSticky(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Close mobile drawer whenever route changes
  useEffect(() => {
    setMobileOpen(false)
  }, [pathname])

  const toggleMobile = () => setMobileOpen(prev => !prev)
  const closeMobile = () => setMobileOpen(false)

  return (
    <div>
      <nav id={sticky ? 'sticky' : 'nav'}>
        <Link to='/' className='navLogoLink'>
          <img
            src={sticky ? Logo : LogoTransparent}
            alt='Ghana Union Logo'
            className='navLogoImg'
          />
        </Link>

        <Link to='/' className={pathname === '/' ? 'activeNav' : ''}>
          Home
        </Link>
        <Link to='/about' className={pathname.startsWith('/about') ? 'activeNav' : ''}>
          About Us
        </Link>
        <Link to='/events' className={pathname.startsWith('/event') ? 'activeNav' : ''}>
          Events
        </Link>
        <Link to='/news' className={pathname.startsWith('/news') ? 'activeNav' : ''}>
          News
        </Link>
        <Link to='/gallery' className={pathname.startsWith('/gallery') ? 'activeNav' : ''}>
          Gallery
        </Link>
        <a href='/#partners'>Partners</a>
        <a href='#form'>Contact Us</a>
        <Link to='/joinus' className={`navJoin ${pathname === '/joinus' ? 'activeNav' : ''}`}>
          Join Us
        </Link>

        <div id='topContact'>
          <Popover content='ghanaunion.cz@gmail.com'>
            <a
              href='mailto:ghanaunion.cz@gmail.com'
              target='_blank'
              rel='noreferrer'
              className='icons'
              aria-label='Email Ghana Union'
            >
              <Icon name='mail' circular inverted size='large' />
            </a>
          </Popover>

          <Popover content='@ghanaunioncz'>
            <a
              href='https://www.instagram.com/ghanaunioncz/?utm_source=ig_web_button_share_sheet&igshid=OGQ5ZDc2ODk2ZA=='
              target='_blank'
              rel='noreferrer'
              className='icons'
              aria-label='Instagram'
            >
              <Icon name='instagram' circular inverted color='black' size='large' />
            </a>
          </Popover>

          <Popover content='GHunioncz'>
            <a
              href='https://www.facebook.com/GHunioncz'
              target='_blank'
              rel='noreferrer'
              className='icons'
              aria-label='Facebook'
            >
              <Icon name='facebook' circular inverted size='large' />
            </a>
          </Popover>
        </div>
      </nav>

      <div id='mobileNav' className={sticky ? 'mobileSticky' : ''}>
        <div id='background' className={sticky ? 'mobileStickyBg' : ''}>
          <Link to='/' onClick={closeMobile}>
            <span id='mobileLogo'>
              <img src={sticky ? Logo : LogoTransparent} width='36px' alt='logo' />
            </span>
          </Link>
          <span
            id='menuButton'
            onClick={toggleMobile}
            aria-label='Toggle navigation menu'
          >
            {mobileOpen ? '\u2715' : '\u2630'}
          </span>
        </div>

        <div id='menuItems' className={mobileOpen ? 'open' : ''}>
          <Link to='/' onClick={closeMobile}>Home</Link>
          <Link to='/about' onClick={closeMobile}>About Us</Link>
          <Link to='/events' onClick={closeMobile}>Events</Link>
          <Link to='/news' onClick={closeMobile}>News</Link>
          <Link to='/gallery' onClick={closeMobile}>Gallery</Link>
          <a href='/#partners' onClick={closeMobile}>Partners</a>
          <a href='#form' onClick={closeMobile}>Contact Us</a>
          <Link to='/joinus' className='mobileJoinLink' onClick={closeMobile}>Join Us</Link>
        </div>
      </div>
    </div>
  )
}

export default Navigation
